exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav{width:100%;height:42px;background:#1e1e1e;position:fixed;top:70px;z-index:9;padding:0 18px;box-sizing:border-box}.main{width:100%;height:100%}.main li{float:left;width:25%;height:100%;text-align:center;color:#fff;font-size:14px;position:relative;transition:all .3s}.main li span{position:absolute;left:50%;top:50%;transform:translateX(-50%) translateY(-50%)}.main .current{color:#7de87d;border-bottom:3px solid #7de87d;box-sizing:border-box;height:90%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-7c560590","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nav.vue
// module id = 53
// module chunks = 0